import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {AngularFireStorage} from '@angular/fire/storage';
import {RealEstateAgentModel} from '../../models/realEstateAgentModel';
import {RealEstateAgentService} from '../../service/real-estate-agent.service';

@Component({
  selector: 'app-real-estate-agent-modal',
  templateUrl: './real-estate-agent-modal.component.html',
  styleUrls: ['./real-estate-agent-modal.component.scss']
})
export class RealEstateAgentModalComponent implements OnInit {

  activeTabIndex: number = 0;
  selectedRealEstateAgentItem: RealEstateAgentModel;
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private realEstateAgentService: RealEstateAgentService,
    private dialogRef: MatDialogRef<RealEstateAgentModalComponent>,
    private storage: AngularFireStorage,
    @Inject(MAT_DIALOG_DATA) realEstateAgent: RealEstateAgentModel) {

    this.selectedRealEstateAgentItem = realEstateAgent;

    this.form = fb.group({
      name: [this.selectedRealEstateAgentItem.name, Validators.required],
      title: [this.selectedRealEstateAgentItem.title],
      phone: [this.selectedRealEstateAgentItem.phone],
      email: [this.selectedRealEstateAgentItem.email],
    });

  }


  ngOnInit() {

  }

  save() {

    if (!this.form.valid) {
      return;
    }

    if (this.selectedRealEstateAgentItem.id) {
      this.realEstateAgentService.editRealEstateAgentItem({
        ...this.selectedRealEstateAgentItem, ...this.form.value,
        updatedAt: new Date().getTime()
      });
    } else {
      this.realEstateAgentService.createRealEstateAgentItem({
        ...this.form.value,
        createdAt: new Date().getTime(),
        updatedAt: new Date().getTime()
      });
    }

    this.dialogRef.close(this.form.value);
  }

  close() {
    this.dialogRef.close();
  }

  onSelectedTabChanged(event) {
    this.activeTabIndex = event.index;
  }


  deleteCoverImage() {
    const fileRef = this.storage.ref(this.selectedRealEstateAgentItem.imageUrlFilePath);
    fileRef.delete();
    this.selectedRealEstateAgentItem.imageUrl = '';
    this.selectedRealEstateAgentItem.imageUrlFilePath = '';
    this.realEstateAgentService.editRealEstateAgentItem(this.selectedRealEstateAgentItem);
  }

  onUploadFinished(event) {
    this.selectedRealEstateAgentItem.imageUrl = event.imageUrl;
    this.selectedRealEstateAgentItem.imageUrlFilePath = event.imageUrlFilePath;
    this.realEstateAgentService.editRealEstateAgentItem(this.selectedRealEstateAgentItem);
  }
}
